<template>
  <div class="faq__item" :class="{ active: isActive }">
    <div class="faq__item-title">
      <button @click="toggle" class="faq__item-button">
        <h4 class="faq__item-title-text">{{ item.title }}</h4>
        <span class="faq__item-button-icon"></span>
      </button>
    </div>
    <div v-show="isActive" class="faq__item-desc">
      {{ item.description }}
    </div>
  </div>
</template>
<script>
export default {
  name: "FaqItem",
  props: {
    item: Object,
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style lang="scss" scoped>
.faq__item {
  padding: 0 20px;
  border-bottom: solid 1px #e9e9eb;
  background-color: #fff;

  &-title {
    position: relative;

    &-text {
      font-size: 14px;
      color: #242424;
    }
  }

  &-button {
    width: 100%;
    text-align: left;
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 21px 0;

    &-icon {
      $size: 8px;
      display: block;
      position: absolute;
      top: 0;
      right: 3px;
      bottom: 0;
      margin: auto;
      width: $size;
      height: $size;
      border-right: 2px solid #363636;
      border-bottom: 2px solid #363636;
      transform: translateY(-$size / 4) rotate(45deg);
      transition: transform 0.2s ease;
      .active & {
        transform: translateY($size / 4) rotate(225deg);
      }
    }
  }

  &-desc {
    margin-bottom: 1em;
    color: var(--grayscale-70);
    font-size: 14px;
  }
}
</style>
